export default {
  title: 'SETTING',

  radioButtonTitle: {
    vi: 'Tiếng Việt',
    en: 'English',
    Dark: 'Dark',
    Light: 'Light',
    Small: 'Small',
    Medium: 'Medium',
    Large: 'Large',
    1: 'Performance',
    2: 'Data',
  },

  listTab: {
    general: 'GENERAL',
    notifications: 'NOTIFICATIONS',
    contact: 'CONTACT',
  },

  saveButton: 'SAVE',

  listTitleGeneral: {
    language: 'Language',
    intraday: 'Intraday',
    theme: 'Theme',
    textSize: 'Text size',
    timeZone: 'Time zone',
    format: 'Format',
    sample: 'Sample',
    date: 'Date',
    time: 'Time',
  },

  nodificationPlatform: 'Platform',
  notificationTitle: 'Email Preferences',

  listRadioNotification: {
    NOTIFICATION_SUBSCRIBE:
      'I would like to receive on-platform notifications from FiinTrade',
    NOTIFICATION_UNSUBSCRIBE: 'I would not like to receive any notification',
  },

  listCheckboxNotification: {
    newsEmailSubscribed:
      'I would like to receive news and updates from FiinTrade',
    notificationEmailSubscribed:
      'I would like to receive notifications of trading events by email',
  },

  listTitleContact: {
    customerService: 'Customer service',
    customerServicesPage: 'Customer Services Page',
    userData: 'User Data',
    lastLoginAttempt: 'Last Login Attempt',
    lastLoginStatus: 'Last Login Status',
    softwareInformation: 'Software Information',
    version: 'Version',
    system: 'System',
  },

  userInfo: {
    title: 'PERSONAL DETAIL',
    myProfile: 'My Profile',
    changePassword: 'Change Password',
    emailAddress: 'Email Address',
    mobileNumber: 'Mobile Number',
    preferenceContact: 'Prefered Contact Method',
    button: {
      save: 'SAVE',
      cancel: 'CANCEL',
    },
    memberShip: 'Membership',
    usingAcc: 'You are now using ',
    endAcc: 'Your plan ends on ',
    reNew: 'RENEW',
    upgrade: 'UPGRADE',

    email: 'Email',
    mobilephone: 'Mobile Number',
  },
  'English (UK)': 'English (UK)',
};
